export const formatDDMMYYYY = (dt) => {
    if (!dt) return "-";
    const dateObj = new Date(dt);
    if (isNaN(dateObj)) return dt;
    const options = {
      timeZone: "Asia/Yangon",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    const formatted = dateObj.toLocaleString("en-GB", options);
    return formatted.replace(",", "");
  };

  export const formatYangon = (dt) => {
    if (!dt) return "-";
    const dateObj = new Date(dt);
    if (isNaN(dateObj)) return dt;
    const options = {
      timeZone: "Asia/Yangon",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    };
    const formatted = dateObj.toLocaleString("en-GB", options);
    return formatted.replace(",", "");
  };
